<template>
  <div>
    <!-- 取得失敗 -->
    <v-alert
      v-if="error"
      type="error"
      dense
      text
      class="mb-2"
    >
      {{ error }}
    </v-alert>

    <!-- 未保存あり: 警告バナー -->
    <v-alert
      v-else-if="unsavedDayCount > 0"
      color="warning"
      text
      class="unsaved-banner mb-2"
    >
      <div class="d-flex align-center">
        <v-icon
          color="warning"
          class="mr-3"
        >
          {{ icons.mdiAlert }}
        </v-icon>
        <span class="text-base font-weight-bold warning--text">
          未保存の営業日が {{ unsavedDayCount }} 日あります
        </span>
        <v-spacer />
        <v-btn
          color="warning"
          small
          :ripple="false"
          @click="$emit('toggle')"
        >
          {{ expanded ? '閉じる' : '確認する' }}
          <v-icon right>
            {{ expanded ? icons.mdiChevronUp : icons.mdiChevronDown }}
          </v-icon>
        </v-btn>
      </div>
      <div
        v-if="periodText"
        class="banner-period text--secondary"
      >
        対象期間: {{ periodText }}
      </div>
    </v-alert>

    <!-- 未保存ゼロ: 安心表示 -->
    <v-alert
      v-else
      color="success"
      text
      dense
      class="mb-2"
    >
      <div class="d-flex align-center">
        <v-icon
          color="success"
          class="mr-3"
        >
          {{ icons.mdiCheckCircle }}
        </v-icon>
        <span class="text-sm font-weight-medium success--text">
          直近の集計はすべて保存されています
        </span>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
  mdiAlert,
  mdiCheckCircle,
  mdiChevronDown,
  mdiChevronUp,
} from '@mdi/js'

export default {
  name: 'UnsavedSummaryBanner',
  props: {
    // 未保存のある営業日数（rows の件数）
    unsavedDayCount: {
      type: Number,
      default: 0,
    },
    // 未保存リストの開閉状態
    expanded: {
      type: Boolean,
      default: false,
    },
    // 診断API取得エラーメッセージ
    error: {
      type: String,
      default: null,
    },
    // 診断の対象期間（YYYY-MM-DD）
    from: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    // 'YYYY-MM-DD' を 'YYYY/M/D' に整形する
    const formatDate = str => {
      const parts = (str || '').split('-')
      if (parts.length !== 3) return str || ''

      return `${parts[0]}/${Number(parts[1])}/${Number(parts[2])}`
    }

    const periodText = computed(() => {
      if (!props.from || !props.to) return ''

      return `${formatDate(props.from)} 〜 ${formatDate(props.to)}`
    })

    return {
      periodText,
      icons: {
        mdiAlert,
        mdiCheckCircle,
        mdiChevronDown,
        mdiChevronUp,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.unsaved-banner {
  border-left: 4px solid var(--v-warning-base) !important;
}

.banner-period {
  margin-top: 4px;
  margin-left: 36px;
  font-size: 12px;
}
</style>
